(() => {
  const raw=value=>String(value??'').trim();
  const PREFIXES=['RUBIES_','SMIFFYS_','WWT_','BO-','WI-','BTS_','SY_','NUNU_','NOVAENGEL_','NE_','BIGBUY_'];
  const candidates=value=>{
    const term=raw(value);
    const squashed=term.replace(/\s+/g,'');
    const found=squashed.match(/^(?:[a-z][a-z0-9]*[-_])?(\d{3,})$/i);
    if(!found)return [term];
    const suffix=found[1];
    const rubiesSizes=['S000','M000','L000','XL000','XS000'];
    const rubiesAlternates=rubiesSizes.map(size=>'RUBIES_'+suffix+size);
    return [...new Set([term,'RUBIES_'+suffix,...rubiesAlternates,suffix,...PREFIXES.map(p=>p+suffix)])];
  };
  const queryForShopify=raw;
  window.F24SearchExpander={version:'1.3.1',queryForShopify,candidates,normalizeKey:x=>raw(x).toLowerCase(),expand:raw};
  const init=async()=>{
    if(!/\/search\/?$/.test(location.pathname))return;
    const url=new URL(location.href);
    const userQuery=url.searchParams.get('f24q')||url.searchParams.get('q')||'';
    document.querySelectorAll('input[type="search"]').forEach(input=>input.value=userQuery);
    const initial=url.searchParams.get('q')||'';
    if(!/^(?:\d{3,}|[a-z0-9]+[-_]\d{3,})$/i.test(initial))return;
    if(url.searchParams.has('f24skip'))return;
    const visible=document.querySelector('.f24-search-empty');
    if(!visible)return;
    const original=candidates(userQuery);
    const pending=original.filter(x=>x.toLowerCase()!==initial.toLowerCase());
    for(const candidate of pending){
      try {
        const testUrl=new URL(url);
        testUrl.searchParams.set('q',candidate);
        testUrl.searchParams.delete('f24q');
        testUrl.searchParams.delete('f24skip');
        testUrl.searchParams.set('section_id','f24-full-search-suggestions');
        const response=await fetch(testUrl.toString(),{headers:{Accept:'text/html'}});
        if(!response.ok)continue;
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const root=doc.querySelector('[data-f24-full-search-results]');
        if(Number(root?.dataset?.totalResults||0)>0){
          const target=new URL(url);
          target.searchParams.set('q',candidate);
          target.searchParams.set('f24q',userQuery);
          target.searchParams.set('f24skip','1');
          target.searchParams.delete('section_id');
          location.replace(target.toString());
          return;
        }
      }catch(_){}
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();